import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { AgendarTarefaComponent } from 'src/app/shared/components/detalhes-obra/agendar-tarefa/agendar-tarefa.component';
import { ObraDescartadaComponent } from 'src/app/shared/components/detalhes-obra/obra-descartada/obra-descartada.component';
import { ObraPerdidaComponent } from 'src/app/shared/components/detalhes-obra/obra-perdida/obra-perdida.component';
import { ReportarErroComponent } from 'src/app/shared/components/detalhes-obra/reportar-erro/reportar-erro.component';
import { ModalReportarErroObraComponent } from 'src/app/shared/components/modais/modal-reportar-erro-obra/modal-reportar-erro-obra.component';
import { Nl2brPipe } from 'src/app/shared/pipes/nl2br.pipe';
import { RangeMinMaxPipe } from 'src/app/shared/pipes/range-min-max.pipe';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { HeaderService } from 'src/app/header/service/header.service';
import { ObraContratadaComponent } from '../../shared/components/detalhes-obra/obra-contratada/obra-contratada.component';

import { HttpClient } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FichaObraImpressaoComponent } from '../ficha-obra-impressao/ficha-obra-impressao.component';
import { FichaDaObraService } from '../service/ficha-da-obra.service';
import { TarefasRelatosService } from '../tarefas-relatos/tarefas-relatos.service';
import { ModalAguardandoDownloadComponent } from 'src/app/shared/components/modal-aguardando-download/modal-aguardando-download.component';


interface ObraDetalhes {
  id: number;
  name: string;
  phase: string;
  isAutomaticPhaseUpdating: boolean;
  endingDate?: Date | null;
  updateDate: Date;
  locationUrl?: string;
  locationDescription?: string;
  neighborhood?: string;
  cep?: string;
  city?: string;
  state?: string;
  categories?: Array<{
    name: string;
    values: Record<string, string>;
  }>;
  marketID?: number;
  moduleId?: number;
  clientSpecific?: {
    marketID?: number;
    responsibleID?: number;
    potentialScore?: number;
  };
  responsibleID?: number;
  recentUpdates?: Array<{
    date: string;
    title: string;
    detail?: string;
    userName?: string;
    eventType?: string;
  }>;
  isReadOnly?: boolean;
  readOnlyReason?: string;
}
 

interface ClienteMercado {
  id: number;
  description: string;
}

interface ResponsavelObra {
  id: number;
  name: string;
}

interface ArquivoObra {
  fileName: string;
  fileDownloadURL?: string;
  fileDescription: string;
}

@Component({
  selector: 'app-detalhe-da-obra',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    RouterModule,
    ObraContratadaComponent,
    ObraDescartadaComponent,
    ObraPerdidaComponent,
    AgendarTarefaComponent,
    ReportarErroComponent,
    ModalReportarErroObraComponent,
    Nl2brPipe,
    RangeMinMaxPipe,
    ModalAguardandoDownloadComponent,
  ],
  templateUrl: './detalhe-da-obra.component.html',
  styleUrl: './detalhe-da-obra.component.scss',
})
export class DetalheDaObraComponent {
  cronogramaExpandido: boolean = false;
  processandoAcao: boolean = false;
  mensagemProcessando: string = 'Aguardando download...';

  responsavel: ResponsavelObra[] = [];
  modalRef?: BsModalRef;
  isLoadingObra: boolean = false;

  produtoProductImages: Array<{ url: string; alt: string }> = [];
  mostrarPaginaImpressao: boolean = false;
  currentIndex = 0;
  isImageModalOpen = false;

  @Input() idObra: number | null = null;
  @Input() moduloId: number | null = null;
  @Input() contextoResultado: boolean = false;
  @Output() loadingObra = new EventEmitter<boolean>();
  @Output() moduleIdLoaded = new EventEmitter<number>();
  @Output() obraNameLoaded = new EventEmitter<string>();
  @Output() fichaBloqueada = new EventEmitter<number | null>();

  obraNaoEncontrada = false;

  isPanelOpen = false;
  panelTitle = '';
  currentPanel: string | null = null;
  score = 0;
  hovered = 0;
  stars = [1, 2, 3, 4, 5];

  showReportErroObra = false;



  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  companyId: any;
  companyName: string = '';
  restrictionKey: any;
  userId: string;

  ArrPotencialObra: any[] = [];
  ArrClienteMercado: ClienteMercado[] = [];
  ArrResponsavelObra: ResponsavelObra[] = [];
  ArrObraDetalhes: ObraDetalhes | null = null;
  ArrListaArquivos: ArquivoObra[] = [];
  ArrContatosObra: any = {};

  dropdownOpen: string | null = null;
  responsavelSelecionado: any | null = null;
  statusSelecionado: any | null = null;

  concorrentes = ['Concorrente A', 'Concorrente B', 'Concorrente C'];
  motivos = ['Preço', 'Prazo', 'Qualidade'];

  private subscriptions: Subscription = new Subscription();
  private _errorHandleService = inject(ErrorHandleService);
  private _tarefasRelatosService = inject(TarefasRelatosService);
  private _router = inject(Router);

  successMessage: string | null = null;
  successMessagePotencial: string | null = null;
  tarefaSelecionada: any = null;

  private _imagemPrincipalObra: { url: string; alt: string } | null = null;

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (this.isImageModalOpen) {
      if (event.key === 'ArrowLeft') {
        this.prevImage(event);
      } else if (event.key === 'ArrowRight') {
        this.nextImage(event);
      }
    }
  }

  constructor(
    private readonly _fichaDaObraService: FichaDaObraService,
    private readonly http: HttpClient,
    private readonly modalService: BsModalService,
    private readonly _headerService: HeaderService,
  ) {
    this.companyId = localStorage.getItem('companyID');
    this.companyName = localStorage.getItem('companyName') || localStorage.getItem('companyTradeName') || '';
    this.restrictionKey = localStorage.getItem('restrictionKey');
    this.userId = localStorage.getItem('userId');
  }

  ngOnInit(): void {
    this.clienteMercado();
    this.popularResponsavel();
    this.detalhesDaObra();
    this.carregarImagensCarrossel();
    this.listarArquivosDetalhesObra();
    this.listarContatosObra();
    this.carregarDadosEmpresa();

    if (this.responsavelSelecionado) {
      const responsavel = this.responsavel.find(
        (r) => r.id === this.responsavelSelecionado,
      );
      if (responsavel) {
        this._fichaDaObraService.setResponsavelSelecionado(responsavel);
      }
    }
  }

  private setSelectsFromDetalhes() {
    if (this.ArrObraDetalhes) {
      if (this.responsavel.length > 0 && this.ArrClienteMercado.length > 0) {
        this.statusSelecionado =
          this.ArrObraDetalhes.marketID ??
          this.ArrObraDetalhes.clientSpecific?.marketID ??
          null;

        this.responsavelSelecionado =
          this.ArrObraDetalhes.responsibleID ??
          this.ArrObraDetalhes.clientSpecific?.responsibleID ??
          null;

        if (this.responsavelSelecionado) {
          const responsavel = this.responsavel.find(
            (r) => r.id === this.responsavelSelecionado,
          );
          if (responsavel) {
            this._fichaDaObraService.setResponsavelSelecionado(responsavel);
          }
        }
      } else {
        console.warn(
          'Arrays responsavel ou ArrClienteMercado ainda não carregados.',
        );
      }
    }
  }

  get moduloAtual(): number | null {
    return this.moduloId ?? this.ArrObraDetalhes?.moduleId ?? null;
  }

  get somenteLeitura(): boolean {
  return this.ArrObraDetalhes?.isReadOnly === true;
  }
 
  get motivoSomenteLeitura(): string {
    return this.ArrObraDetalhes?.readOnlyReason || 'Obra encerrada';
  }

  selectResponsavel(): void {
    if (this.somenteLeitura) return;
  
    if (this.idObra && this.responsavelSelecionado) {
      const responsavel = this.responsavel.find(
        (r) => r.id === this.responsavelSelecionado,
      );
      if (responsavel) {
        this._fichaDaObraService.setResponsavelSelecionado(responsavel);
      }
  
      const body = { responsibleID: Number(this.responsavelSelecionado) };
      this._fichaDaObraService
        .updateResponsavelObra(this.idObra, body, this.moduloAtual)
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.successMessage = 'Respons\u00e1vel atualizado com sucesso!';
              setTimeout(() => {
                this.successMessage = null;
              }, 2000);
            } else {
              this._errorHandleService.throwConsoleError(res.message);
            }
          },
          error: (err) => {
            console.error('Erro ao atualizar o responsável:', err);
          },
        });
  }
}
 
  atualizaResponsavelObra(): void {
    if (!this.idObra) {
      console.error('ID da obra não foi fornecido.');
      return;
    }
  
    const body = {
      responsibleID: 0,
    };
  
    this.subscriptions.add(
      this._fichaDaObraService
        .updateResponsavelObra(this.idObra, body, this.moduloAtual)
        .subscribe({
          next: (res) => {
            if (res.success) {
              console.log('Responsável atualizado com sucesso:', res.message);
            } else {
              this._errorHandleService.throwConsoleError(res.message);
            }
          },
          error: (err) => {
            console.error('Erro ao atualizar o responsável:', err);
          },
        }),
    );
  }

  selectClienteMercado(): void {
    if (this.somenteLeitura) return;
  
    if (this.idObra && this.statusSelecionado) {
      const market = this.ArrClienteMercado.find(
        (m) => m.id == this.statusSelecionado,
      );
      const responsavel = this.responsavel.find(
        (r) => r.id == this.responsavelSelecionado,
      );
  
      const body = {
        marketID: market ? market.id : 0,
        description: market ? market.description : '',
        responsibleID: responsavel ? responsavel.id : 0,
      };
  
      this._fichaDaObraService
        .updateClienteMercado(this.idObra, body, this.moduloAtual)
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.successMessage = 'Cliente mercado atualizado com sucesso!';
              setTimeout(() => {
                this.successMessage = null;
              }, 2000);
            } else {
              this._errorHandleService.throwConsoleError(res.message);
            }
          },
          error: (err) => {
            console.error('Erro ao atualizar o cliente mercado:', err);
          },
        });
    }
  }
  atualizaClienteMercado(): void {
    if (!this.idObra) {
      console.error('ID da obra não foi fornecido.');
      return;
    }
  
    const market = this.ArrClienteMercado.find(
      (m) => m.id == this.statusSelecionado,
    );
    const responsavel = this.responsavel.find(
      (r) => r.id == this.responsavelSelecionado,
    );
  
    const body = {
      marketID: market ? market.id : 0,
      description: market ? market.description : '',
      responsibleID: responsavel ? responsavel.id : 0,
    };
  
    this._fichaDaObraService
      .updateClienteMercado(this.idObra, body, this.moduloAtual)
      .subscribe({
        next: (res) => {
          if (res.success) {
            console.log(
              'Status/Responsável atualizados com sucesso:',
              res.message,
            );
          } else {
            this._errorHandleService.throwConsoleError(res.message);
          }
        },
        error: (err) => {
          console.error('Erro ao atualizar status/responsável:', err);
        },
      });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['idObra'] && changes['idObra'].currentValue) {
      this.detalhesDaObra();
      this.carregarImagensCarrossel();
      this.listarContatosObra();
      this.listarArquivosDetalhesObra();
    }
    if (changes['moduloId'] && changes['moduloId'].currentValue && !changes['idObra']) {
      this.detalhesDaObra();
      this.carregarImagensCarrossel();
      this.listarContatosObra();
      this.listarArquivosDetalhesObra();
    }
  }

  rate(value: number): void {
    if (this.somenteLeitura) return;
    this.score = value;
    this.salvarAlteracoes();
  }

  hover(value: number): void {
    this.hovered = value;
  }

  atualizarListaTarefas(novaTarefa: any) {
    this._tarefasRelatosService.emitirAtualizacao();
    this.closePanel();
  }

  salvarAlteracoes() {
  this._fichaDaObraService
    .updatePotencialObra(this.idObra, { score: this.score }, this.moduloAtual)
    .subscribe({
      next: (res) => {
        if (res.success) {
          this.successMessagePotencial = 'Potencial atualizado com sucesso!';
          setTimeout(() => {
            this.successMessagePotencial = null;
          }, 3000);
        } else {
          this._errorHandleService.throwConsoleError(res.message);
        }
      },
      error: (err) => {
        console.error('Erro ao salvar alterações:', err);
      },
    });
}

  detalhesDaObra(): void {
  this.loadingObra.emit(true);
  this.obraNaoEncontrada = false;
 
  this._fichaDaObraService.detalheDaObra(this.idObra, this.moduloId).subscribe({
    next: (response) => {
      if (response.success) {
        this.ArrObraDetalhes = response.data;
 
        const moduloResolvido = this.moduloId ?? this.ArrObraDetalhes?.moduleId;
        if (moduloResolvido) {
          this.moduleIdLoaded.emit(moduloResolvido);
        }
 
        if (this.ArrObraDetalhes?.name) {
          this.obraNameLoaded.emit(this.ArrObraDetalhes.name);
        }
 
        this.score =
          this.ArrObraDetalhes?.clientSpecific?.potentialScore ?? 0;
 
        this.responsavelSelecionado =
          this.ArrObraDetalhes?.clientSpecific?.responsibleID ?? null;
        this.statusSelecionado =
          this.ArrObraDetalhes?.clientSpecific?.marketID ?? null;
 
        if (!this.moduloId) {
          this.listarContatosObra();
          this.listarArquivosDetalhesObra();
        }
      }
      this.loadingObra.emit(false);
    },
    error: (err) => {
      this.ArrObraDetalhes = null;
      this.loadingObra.emit(false);
 
      const corpo = err?.error ?? err;
      if (err?.status === 403 && corpo?.data?.locked) {
        this.fichaBloqueada.emit(corpo.data.moduleId ?? this.moduloId);
        return;
      }
 
      if (err?.status === 404) {
        this._router.navigate(['/404'], { replaceUrl: true });
        return;
      }

      console.error('Erro ao carregar detalhes da obra:', err);
    },
  });
}

  clienteMercado(): void {
    this.subscriptions.add(
      this._fichaDaObraService.listaClienteMercado(this.idObra).subscribe({
        next: (res) => {
          if (res.success) {
            this.ArrClienteMercado = res.data;
            this.setSelectsFromDetalhes();
          } else {
            this._errorHandleService.throwConsoleError(res.message);
          }
        },
      }),
    );
  }

  private readonly ordemNumeros = [
    'unidades', 'padrão', 'banheiros',
    'unidades por andar', 'minha casa minha vida', 'janelas',
    'andares', 'área útil', 'elevadores',
    'blocos', 'área total', 'vagas',
    'coberturas', 'apartamentos', 'área do terreno',
  ];

  ordemNumero(label: string): number {
    if (this.ArrObraDetalhes?.moduleId !== 234) return 0;
    const chave = String(label ?? '').trim().toLowerCase().replace(/ no total$/, '');
    const idx = this.ordemNumeros.indexOf(chave);
    return idx === -1 ? this.ordemNumeros.length : idx;
  }

  getKeys(obj: any): string[] {
    if (!obj) return [];
    return Object.keys(obj).filter(
      (key) =>
        key.trim().toLowerCase() !== 'área do terreno' &&
        !this.chavesResumo.includes(key) &&
        String(obj[key] ?? '').trim() !== '',
    );
  }

  get chavesResumo(): string[] {
    const isImobiliario = this.ArrObraDetalhes?.moduleId === 234;
    return isImobiliario
      ? ['Unidades', 'Padrão', 'Andares', 'Blocos', 'Vagas', 'Área Útil']
      : ['Valor', 'Setor', 'Prazo', 'Info'];
  }

  get tipoObra(): string {
    const resumo = this.chavesResumo;
    const categoria = this.ArrObraDetalhes?.categories?.find(
      (c) =>
        c?.values &&
        !Array.isArray(c.values) &&
        resumo.some((chave) => chave in c.values),
    );
    return categoria?.name?.trim() ?? '';
  }

  ehCronograma(categoria: any): boolean {
    return categoria?.name === 'Cronograma';
  }

  ehCategoriaUnidades(categoria: any): boolean {
    return String(categoria?.name ?? '')
      .trim()
      .toLowerCase()
      .startsWith('números - apartamentos');
  }

  itensUnidade(categoria: any): { rotulo: string; detalhes: { label: string; value: string }[] }[] {
    const values = categoria?.values;
    if (!values || Array.isArray(values)) return [];
    return Object.entries(values).map(([chave, valor]) => ({
      rotulo: String(chave).trim().replace(/^ap\b/i, 'Apartamento'),
      detalhes: String(valor ?? '')
        .split('|')
        .map((item) => item.trim())
        .filter((item) => item.length > 0)
        .map((item) => {
          const idx = item.indexOf(':');
          return idx === -1
            ? { label: '', value: item }
            : { label: item.slice(0, idx).trim(), value: item.slice(idx + 1).trim() };
        }),
    }));
  }

  colunasUnidades(itens: { detalhes: { label: string }[] }[]): string[] {
    const ordem = ['Área', 'Unidades', 'Por andar', 'Banheiros', 'Lavabos', 'Vagas'];
    const norm = (t: string) => t.trim().toLowerCase();
    const extras: string[] = [];
    itens.forEach((item) =>
      item.detalhes.forEach((d) => {
        if (d.label && !ordem.some((o) => norm(o) === norm(d.label)) && !extras.includes(d.label)) {
          extras.push(d.label);
        }
      }),
    );
    return [...ordem, ...extras];
  }

  valorUnidade(detalhes: { label: string; value: string }[], coluna: string): string {
    return detalhes.find((d) => d.label.trim().toLowerCase() === coluna.trim().toLowerCase())?.value ?? '-';
  }

  getOpcoes(valor: string): string[] {
    if (!valor) return [];
    return valor
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
  }

  temVariasOpcoes(categoria: string, valor: string): boolean {
    return this.ArrObraDetalhes?.moduleId === 234 &&
      categoria === 'Mais Detalhes' &&
      typeof valor === 'string' &&
      valor.includes(',');
  }

  isValorLivre(chave: string): boolean {
    const chavesLivres = ['Descrição', 'Anotações', 'Observações'];
    return chavesLivres.includes(chave);
  }

  getLabelCategoria(chave: string): string {
    const mapa: { [key: string]: string } = {
      valorDolar: 'Valor (US$)',
    };
    return mapa[chave] || chave;
  }

  getModuleName(moduleId: number | null): string {
    if (!moduleId) return '';
    const moduleNames: { [key: number]: string } = {
      234: 'Imobiliário',
      5: 'Industrial',
      6: 'Edificações',
      7: 'Infraestrutura',
    };
    return moduleNames[moduleId] || '';
  }

  getConstructorName(constructorId: number | null): string {
    if (!constructorId) return '';
    if (this.ArrContatosObra?.companies && this.ArrContatosObra.companies.length > 0) {
      const company = this.ArrContatosObra.companies.find(
        (c: any) => c.companyId === constructorId
      );
      return company?.companyTradeName || '';
    }
    return '';
  }

  getConstructorCompanyId(): number | null {
    if (this.ArrContatosObra?.companies && this.ArrContatosObra.companies.length > 0) {
      const companyId = this.ArrContatosObra.companies[0].companyId || null;
      return companyId;
    }
    return null;
  }

 atualizaPotencialDaObra(): void {
  if (!this.idObra) {
    console.error('ID da obra não foi fornecido.');
    return;
  }
 
  const body = {
    score: this.score,
  };
 
  this.subscriptions.add(
    this._fichaDaObraService
      .updatePotencialObra(this.idObra, body, this.moduloAtual)
      .subscribe({
        next: (res) => {
          if (res.success) {
            console.log('Potencial atualizado com sucesso:', res.message);
          } else {
            this._errorHandleService.throwConsoleError(res.message);
          }
        },
        error: (err) => {
          console.error('Erro ao atualizar o potencial:', err);
        },
      }),
  );
}

 abrirFichaImpressao(): void {
  this.loadingObra.emit(true);
  const body = {
    workDetails: [
      { workId: String(this.idObra), moduleId: String(this.moduloAtual ?? 0) },
    ],
  };
  this._fichaDaObraService.infoImpressao(body).subscribe(
    (response) => {
      if (response.success && response.data.works.length > 0) {
        const modalRef = this.modalService.show(FichaObraImpressaoComponent, {
          initialState: {
            idObra: this.idObra,
            dadosApi: response.data,
          },
          class: 'modal-lg',
        });

        if (modalRef.content) {
          modalRef.content.modalRef = modalRef;
        }
      } else {
        console.error('Nenhuma obra encontrada na resposta:', response);
      }
      this.loadingObra.emit(false);
    },
    (error) => {
      console.error('Erro ao buscar detalhes da impressão:', error);
      this.loadingObra.emit(false);
    },
  );
}

downloadPDFFicha(): void {
  if (!this.idObra) {
    console.error('ID da obra não foi fornecido.');
    return;
  }

  const body = {
    workDetails: [
      { workId: String(this.idObra), moduleId: String(this.moduloAtual ?? 0) },
    ],
  };

  this.mensagemProcessando = 'Aguardando download do PDF...';
  this.processandoAcao = true;

  this._fichaDaObraService.downloadPDF(body).subscribe({
    next: (blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `FichaObra_${this.idObra}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
      this.processandoAcao = false;
    },
    error: (err) => {
      console.error('Erro ao baixar o PDF:', err);
      this.processandoAcao = false;
    },
  });
}
  fecharImpressao = () => {
    this.mostrarPaginaImpressao = false;
  };

  listarArquivosDetalhesObra(): void {
    if (!this.idObra) {
      console.error('ID da obra não foi fornecido.');
      return;
    }

    this._fichaDaObraService.listarArquivosObra(this.idObra, this.moduloAtual).subscribe({
      next: (res) => {
        if (res.success) {
          this.ArrListaArquivos = res.data;
        } else {
          this._errorHandleService.throwConsoleError(res.message);
        }
      },
      error: (err) => {
        console.error('Erro ao listar arquivos:', err);
      },
    });
  }

listarContatosObra(): void {
  const modulo = this.moduloAtual;
  if (!this.idObra || !modulo) return;
 
  this._fichaDaObraService.listarContatosObra(this.idObra, modulo).subscribe({
    next: (res) => {
      if (res.success) {
        this.ArrContatosObra = res.data;
      } else {
        this._errorHandleService.throwConsoleError(res.message);
      }
    },
    error: (err) => {
      console.error('Erro ao listar contatos:', err);
    },
  });
}

  carregarDadosEmpresa(): void {
    const companyId = localStorage.getItem('companyID');
    const restrictionKey = localStorage.getItem('restrictionKey');

    if (!companyId || !restrictionKey) {
      console.warn('companyID ou restrictionKey não encontrados no localStorage');
      return;
    }

    this._headerService.dadosFornecedor(companyId, restrictionKey).subscribe({
      next: (res) => {
        if (res && res.data) {
          this.companyId = res.data.companyID;
          this.companyName = res.data.tradingName || res.data.name || '';
        } else {
          console.warn('Resposta da API dadosFornecedor está vazia ou nula');
        }
      },
      error: (err) => {
        console.error('Erro ao carregar dados da empresa:', err);
      },
    });
  }

  popularResponsavel(): void {
    this._fichaDaObraService.popularResponsavelObra().subscribe(
      (response) => {
        this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );

        this.setSelectsFromDetalhes();
      },
      (error) => {
        console.error('Erro ao buscar responsáveis:', error);
      },
    );
  }

  openPanel(panel: string): void {
  if (this.somenteLeitura) return;
 
  switch (panel) {
    case 'contratada':
      this.abrirObraContratada();
      return;
    case 'perdida':
      this.abrirObraPerdida();
      return;
    case 'descartada':
      this.abrirObraDescartada();
      return;
    default:
      this.panelTitle = '';
      return;
  }
}

  abrirObraContratada(): void {
  if (!this.idObra) return;
  const modalRef = this.modalService.show(ObraContratadaComponent, {
    class: 'modal-dialog-centered',
    initialState: { idObra: this.idObra, moduloId: this.moduloAtual },
  });
 
  if (modalRef?.content) {
    modalRef.content.loading.subscribe((v) => this.loadingObra.emit(v));
    modalRef.content.close.subscribe(() => modalRef.hide());
    modalRef.content.actionConfirmed.subscribe(() => {
      this.detalhesDaObra();
      modalRef.hide();
    });
  }
}

  abrirObraDescartada(): void {
  if (!this.idObra) return;
  const modalRef = this.modalService.show(ObraDescartadaComponent, {
    class: 'modal-dialog-centered',
    initialState: { idObra: this.idObra, moduloId: this.moduloAtual },
  });
 
  if (modalRef?.content) {
    modalRef.content.loading.subscribe((v) => this.loadingObra.emit(v));
    modalRef.content.close.subscribe(() => modalRef.hide());
    modalRef.content.actionConfirmed.subscribe(() => {
      this.detalhesDaObra();
      modalRef.hide();
    });
  }
}
 
abrirObraPerdida(): void {
  if (!this.idObra) return;
  const modalRef = this.modalService.show(ObraPerdidaComponent, {
    class: 'modal-dialog-centered',
    initialState: { idObra: this.idObra, moduloId: this.moduloAtual },
  });
 
  if (modalRef?.content) {
    modalRef.content.loading.subscribe((v) => this.loadingObra.emit(v));
    modalRef.content.close.subscribe(() => modalRef.hide());
    modalRef.content.actionConfirmed.subscribe(() => {
      this.detalhesDaObra();
      modalRef.hide();
    });
  }
}

  closePanel(): void {
    this.isPanelOpen = false;
    this.currentPanel = null;
    this.tarefaSelecionada = null;
  }

  openImageModal(index: number): void {
    this.currentIndex = index;
    this.isImageModalOpen = true;
  }

  closeImageModal(): void {
    this.isImageModalOpen = false;
  }

  prevImage(event: Event): void {
    event.stopPropagation();
    this.currentIndex =
      (this.currentIndex - 1 + this.produtoProductImages.length) %
      this.produtoProductImages.length;
  }

  nextImage(event: Event): void {
    event.stopPropagation();
    this.currentIndex =
      (this.currentIndex + 1) % this.produtoProductImages.length;
  }

  reportarErro() {
  if (this.somenteLeitura) return;
  this.showReportErroObra = true;
}
  fecharReportErroObra() {
    this.showReportErroObra = false;
  }

  getUnidades(): string {
    if (!this.ArrObraDetalhes?.categories?.length) {
      return '';
    }
    for (const categoria of this.ArrObraDetalhes.categories) {
      if (categoria.values && categoria.values['Unidades'] !== undefined) {
        return categoria.values['Unidades'];
      }
    }
    return '';
  }

  get numerosResumo(): Array<{ label: string; value: string }> {
    if (!this.ArrObraDetalhes?.categories?.length) {
      return [];
    }

    const chavesDesejadas = this.chavesResumo;

    const resultado: Array<{ label: string; value: string }> = [];

    for (const categoria of this.ArrObraDetalhes.categories) {
      if (!categoria.values) continue;
      for (const chave of chavesDesejadas) {
        if (resultado.length >= 6) return resultado;
        const valor = categoria.values[chave];
        if (valor !== undefined && valor !== null && valor !== '' && valor !== '0' && valor !== '-') {
          resultado.push({ label: this.getLabelCategoria(chave), value: this.formatarValorNumeros(chave, valor) });
        }
      }
    }

    return resultado;
  }

  formatarValorNumeros(chave: string, valor: any): string {
    const texto = String(valor ?? '').trim();
    if (!texto) return '';
    const isArea = chave.trim().toLowerCase().startsWith('área');
    return isArea && !/m[²2]/i.test(texto) ? `${texto} m²` : texto;
  }

  formatarEndereco(endereco: string | null | undefined): string {
    if (!endereco) return '';
    return endereco
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/[\r\n]+/g, ' ')
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  carregarImagensCarrossel(): void {
    if (!this.idObra) return;
    this._fichaDaObraService.imagensCarrosselObra(this.idObra, this.moduloId).subscribe({
      next: (res) => {
        if (res.success && Array.isArray(res.data)) {
          const imagemPrincipal = res.data.find((img) => img.imageTypeId === 1);
          this._imagemPrincipalObra = imagemPrincipal
            ? {
                url: imagemPrincipal.imageFilePath || '',
                alt:
                  imagemPrincipal.imageDescription ||
                  'Imagem principal da obra',
              }
            : null;

          this.produtoProductImages = res.data
            .filter((img) => img.imageTypeId === 4)
            .map((img, idx) => ({
              url: img.imageFilePath || '',
              alt: img.imageDescription || `Imagem ${idx + 1} da obra`,
              imageTypeId: img.imageTypeId,
            }));
        } else {
          this._imagemPrincipalObra = null;
          this.produtoProductImages = [];
        }
      },
      error: (err) => {
        this._imagemPrincipalObra = null;
        this.produtoProductImages = [];
        console.error('Erro ao carregar imagens do carrossel:', err);
      },
    });
  }

  get imagemPrincipalObra() {
    return this._imagemPrincipalObra;
  }

  onTarefaCriada() {
    this._tarefasRelatosService.emitirAtualizacao();
    this.closePanel();
  }

  onPainelLoading(status: boolean) {
    this.isLoadingObra = status;
  }

 baixarPDF(arquivo: any) {
  if (!this.idObra || !arquivo?.fileName) {
    console.error('Arquivo inválido.');
    return;
  }

  this.mensagemProcessando = 'Aguardando download do PDF...';
  this.processandoAcao = true;

  this._fichaDaObraService.downloadArquivoObra(this.idObra, arquivo.fileName).subscribe({
    next: (blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = arquivo.fileName || 'arquivo.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
      this.processandoAcao = false;
    },
    error: (err) => {
      console.error('Erro ao baixar o arquivo:', err);
      this.processandoAcao = false;
    },
  });
}

  toggleCronograma() {
    this.cronogramaExpandido = !this.cronogramaExpandido;
  }

  getCronogramaArray(categoria: any): string[] {
    if (!categoria || categoria.name !== 'Cronograma' || !categoria.values)
      return [];
    if (Array.isArray(categoria.values)) return categoria.values;
    return Object.values(categoria.values);
  }

  cronogramaItens(categoria: any): { data: string | null; texto: string }[] {
    return this.getCronogramaArray(categoria).map((entry) => {
      let texto = String(entry).trim();
      let data: string | null = null;

      const trailing = texto.match(/(\d{2}\/\d{2}\/\d{4})\.?\s*$/);
      const leading = texto.match(/^(\d{2}\/\d{2}\/\d{4})\s*[-–:]?\s*/);

      if (trailing) {
        data = trailing[1];
        texto = texto.slice(0, trailing.index).trim();
      } else if (leading) {
        data = leading[1];
        texto = texto.slice(leading[0].length).trim();
      }

      return { data, texto };
    });
  }



  get dataTerminoFormatada(): string {
    const data: any = this.ArrObraDetalhes?.endingDate;

    if (data && data !== '-') {
      const dataStr = typeof data === 'string' ? data : data.toISOString();

      if (!dataStr.startsWith('0001-01-01')) {
        const dataObj = new Date(dataStr);

        if (!isNaN(dataObj.getTime())) {
          return this.capitalizar(
            dataObj.toLocaleDateString('pt-BR', {
              year: 'numeric',
              month: 'long',
            }),
          );
        }
      }
    }

    const prazo: any = this.ArrObraDetalhes?.categories?.[0]?.values;
    if (prazo && prazo['Prazo'] && prazo['Prazo'] !== '-') {
      return prazo['Prazo'];
    }

    return 'Não informado';
  }

  private toTitleCase(texto: string): string {
    const preposicoes = ['de', 'da', 'do', 'dos', 'das', 'e'];
    const siglas = ['cep', 'sp', 'rj', 'mg', 'rs', 'sc', 'pr', 'ba', 'pe', 'ce', 'pa', 'am', 'rr', 'ap', 'to', 'ma', 'pi', 'rn', 'pb', 'al', 'se', 'df', 'go', 'mt', 'ms', 'es', 'ac', 'ro'];

    const emPartes = texto.toLowerCase().split(' ').map((palavra, i) => {
      const partes = palavra.split('/').map((p) => {
        if (i > 0 && preposicoes.includes(p)) return p;
        return p.charAt(0).toUpperCase() + p.slice(1);
      });
      return partes.join('/');
    });

    let resultado = emPartes.join(' ');
    siglas.forEach((sigla) => {
      resultado = resultado.replace(new RegExp(`\\b${sigla}\\b`, 'gi'), sigla.toUpperCase());
    });

    return resultado;
  }

  private normalizarEndereco(html: string | undefined): string {
    if (!html) return '';
    return this.toTitleCase(
      html
        .replace(/<p[^>]*>/gi, '')
        .replace(/<\/p>/gi, '')
        .replace(/<br\s*\/?>/gi, ' - ')
        .replace(/\s+/g, ' ')
        .trim()
    );
  }

  get enderecoFormatado(): string {
    return this.normalizarEndereco(this.ArrObraDetalhes?.locationDescription);
  }

  get enderecoCompleto(): string {
    const base = this.normalizarEndereco(this.ArrObraDetalhes?.locationDescription);
    const cep = this.ArrObraDetalhes?.cep;
    if (!base) return '';
    if (cep && !base.toLowerCase().includes(cep)) {
      return `${base} - CEP ${cep}`;
    }
    return base;
  }

  get dataAtualizacaoFormatada(): string {
    const data = this.ArrObraDetalhes?.updateDate;

    if (!data) return '';

    const dataStr = typeof data === 'string' ? data : data.toISOString();

    const dataObj = new Date(dataStr);

    if (isNaN(dataObj.getTime())) return '';

    return this.capitalizar(
      dataObj.toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: 'long',
      }),
    );
  }

  private capitalizar(texto: string): string {
    return texto.charAt(0).toUpperCase() + texto.slice(1);
  }
}
